// @ts-nocheck
import { Magazine } from "apps/magazines/models/magazine";
import { ActaUser } from "pa_kit/apps/user/models/user";
import ApiService from 'services/api';
import { Subscription } from "./subscription";
import { University } from "apps/university/models/university";
import { Order, OrderEssential } from "apps/orders/models/order";

export const genders = [
    {value: '', label: '-Seleziona sesso-'},
    {value: 'male', label: 'Maschile'},
    {value: 'female', label: 'Femminile'}
];

export const jobs = [
    {value: '', label: '-Seleziona titolo professionale-'},
    {value: 'obstetrician', label: 'Ostetrica/o'}
];

export const degrees = [
    {value: '', label: '-Seleziona tipo diploma-'},
    {value: 'altro', label: 'Altro'},
    {value: 'biennio_superiore', label: 'Biennio superiore'},
    {value: 'istituto_arte', label: 'Istituto d’arte'},
    {value: 'istituto_magistrale', label: 'Istituto magistrale'},
    {value: 'istituto_professionale', label: 'Istituto professionale'},
    {value: 'istituto_tecnico', label: 'Istituto tecnico'},
    {value: 'liceo_artistico', label: 'Liceo artistico'},
    {value: 'liceo_classico', label: 'Liceo classico'},
    {value: 'liceo_linguistico', label: 'Liceo linguistico'},
    {value: 'liceo_scientifico', label: 'Liceo scientifico'},
];

export const ages = [
    {value: '', label: '-Seleziona fascia età-'},
    {value: '20', label: 'Fino a 20'},
    {value: '21-25', label: '21-25'},
    {value: '26-30', label: '26-30'},
    {value: '31-35', label: '31-35'},
    {value: '36-40', label: '36-40'},
    {value: '41-45', label: '41-45'},
    {value: '46-50', label: '46-50'},
    {value: '51-55', label: '51-55'},
    {value: '55-60', label: '55-60'},
    {value: '61-65', label: '61-65'},
    {value: '66', label: '66 o più'},
];

export const states = [
    {value: 'all', label: 'Mostra tutte/i'},
    // {value: 'active', label: 'Iscritte/i'},
    {value: 'paused', label: 'Sospese/i'},
    {value: 'deleted', label: 'Cancellate/i'}
];

export const subStates = [
    {value: 'active', label: 'Attiva'},
    {value: 'paused', label: 'Sospesa'},
    {value: 'deleted', label: 'Cancellata'}
];

export class Subscriber {

    constructor(data) {
        this.id = data.id;
        this.first_name = data.first_name;
        this.last_name = data.last_name;

        this.n_sub = data.n_sub;
        this.order = data.order_data ? new Order(data.order_data) : "";
        this.state = data.state;

        this.fiscal_code = data.fiscal_code;
        this.birth_date = data.birth_date;
        this.birth_country = data.birth_country;
        this.birth_city = data.birth_city;
        this.birth_province = data.birth_province;
        this.gender = data.gender;
        this.nationality = data.nationality;
        this.piva = data.piva;
        this.residence_document_expire_date = data.residence_document_expire_date;
        this.residence_document_type = data.residence_document_type;
        
        this.residence_address = data.residence_address;
        this.residence_place = data.residence_place;
        this.residence_nation = data.residence_nation;
        this.residence_postal_code = data.residence_postal_code;
        this.residence_city = data.residence_city;
        this.residence_province = data.residence_province;
        this.residence_send_correspondence = data.residence_send_correspondence;
        this.residence_send_magazine = data.residence_send_magazine_data?.map((magazine) => new Magazine(magazine)) || [];
        
        this.domicile_address = data.domicile_address;
        this.domicile_place = data.domicile_place;
        this.domicile_nation = data.domicile_nation;
        this.domicile_postal_code = data.domicile_postal_code;
        this.domicile_city = data.domicile_city;
        this.domicile_province = data.domicile_province;
        this.domicile_send_correspondence = data.domicile_send_correspondence;
        this.domicile_send_magazine = data.domicile_send_magazine_data?.map((magazine) => new Magazine(magazine)) || [];
        
        this.job_domicile_entity_name = data.job_domicile_entity_name;
        this.job_domicile_address = data.job_domicile_address;
        this.job_domicile_place = data.job_domicile_place;
        this.job_domicile_nation = data.job_domicile_nation;
        this.job_domicile_postal_code = data.job_domicile_postal_code;
        this.job_domicile_city = data.job_domicile_city;
        this.job_domicile_province = data.job_domicile_province;
        this.job_domicile_send_correspondence = data.job_domicile_send_correspondence;
        
        this.contacts = data.contacts ? data.contacts : [];
        this.email = data.email;
        this.pec = data.pec;
        
        this.degree = data.degree;
        this.job_qualification = data.job_qualification;
        this.job_qualification_nation = data.job_qualification_nation;
        this.job_qualification_date = data.job_qualification_date;
        this.university = data.university_data ? new University(data.university_data) : "";
        this.university_free_text = data.university_free_text;
        this.university_province = data.university_province;
        this.university_city = data.university_city;
        this.other_entity = data.order_entity;
        
        this.master = data.master;
        this.master_clinical_care = data.master_clinical_care;
        this.degree = data.degree;
        
        this.extra_education = data.extra_education ? data.extra_education : [];
        
        this.measures = data.measures ? data.measures : [];
        
        this.notes = data.notes;
        this.ongoing_transfer = data.ongoing_transfer;
        this.freelance = data.freelance;
        this.enpapi_sub = data.enpapi_sub;
        this.tracc_290_tax = data.tracc_290_tax;
        this.association_name = data.association_name;
        
        this.correspondence_files = data.correspondence_files ? data.correspondence_files : [];
        this.curricula_files = data.curricula_files ? data.curricula_files : [];
        this.personal_documents_files = data.personal_documents_files ? data.personal_documents_files : [];
        this.permit_files = data.permit_files ? data.permit_files : [];
        this.study_title_files = data.study_title_files ? data.study_title_files : [];
        this.other_files = data.other_files ? data.other_files : [];

        this.custom_files = data.custom_files ? data.custom_files : [];
        
        this.last_update = data.last_update;
        this.user_last_update = new ActaUser(data.user_data);
    }

    async getSubscriptions() {
        let subscriptions =  await ApiService.getSubscriptions(this.id);
        let sub_history = [];
        let active_subscription = null;

        if(subscriptions) {
            sub_history = subscriptions
            .map(sub => new Subscription(sub))
            .sort((a, b) => new Date(a.date_sub_start) - new Date(b.date_sub_start));
            

            let active_sub = subscriptions.filter(sub => (sub.state === 'active' || sub.state === 'paused'));
            if (active_sub.length > 0) {
                active_subscription = new Subscription(active_sub[0]);
            }
        }
        
        return {
            subscription_history: sub_history,
            active_subscription: active_subscription
        };
    }
}


export class SubscriberSimple {

    constructor(data) {
        this.id = data.id;
        this.first_name = data.first_name;
        this.last_name = data.last_name;

        this.n_sub = data.n_sub;
        this.order = data.order_data ? new Order(data.order_data) : "";
        this.state = data.state;

        this.fiscal_code = data.fiscal_code;
        this.birth_date = data.birth_date;
        this.birth_city = data.birth_city;
        this.job_qualification = data.job_qualification;
        this.residence_document_expire_date = data.residence_document_expire_date;
    }  
    
    async getSubscriptions() {
        let subscriptions =  await ApiService.getSubscriptions(this.id);
        let sub_history = [];
        let active_subscription = null;

        if(subscriptions) {
            sub_history = subscriptions
            .map(sub => new Subscription(sub))
            .sort((a, b) => new Date(a.date_sub_start) - new Date(b.date_sub_start));
            

            let active_sub = subscriptions.filter(sub => (sub.state === 'active' || sub.state === 'paused'));
            if (active_sub.length > 0) {
                active_subscription = new Subscription(active_sub[0]);
            }
        }
        
        return {
            subscription_history: sub_history,
            active_subscription: active_subscription
        };
    }
}

export class SubscriberEssential {

    constructor(data) {
        this.id = data.id;
        this.first_name = data.first_name; 
        this.last_name = data.last_name; 
        this.fiscal_code = data.fiscal_code;
        this.order = data.order_data ? new OrderEssential(data.order_data) : "";
    }
}